module.exports = __webpack_public_path__ + "img/icon-arrow-gray.0a88d0c7.svg";